module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "question-edit"
  }, [_c('app-header', {
    staticClass: "header"
  }), _c('ul', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v(_vm._s(_vm.$t('Home')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/master"
    }
  }, [_vm._v(_vm._s(_vm.$t('Master Manage')))])], 1), _c('li', [_c('router-link', {
    attrs: {
      "to": "/question"
    }
  }, [_vm._v(_vm._s(_vm.$t('Normal Questions List')))])], 1), _c('li', {
    staticClass: "active"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('Normal Questions Edit')))])])]), _c('h2', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.$t('Normal Questions Edit')))]), (_vm.isSearchEnd) ? _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "row margin-top"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("タイトル")]), _c('div', {
    staticClass: "col-sm-10"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.title),
      expression: "title"
    }],
    staticClass: "form-control",
    class: {
      required: !_vm.validation.title
    },
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": _vm._s(_vm.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.title = $event.target.value
      }
    }
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.validation.title),
      expression: "!validation.title"
    }],
    staticClass: "validation-msg"
  }, [_vm._v(_vm._s(_vm.$t('validations.required')))])])]), _vm._l((_vm.questions), function(question, index) {
    return _c('div', {
      staticClass: "row margin-top"
    }, [_c('label', {
      staticClass: "col-sm-2 control-label"
    }, [_vm._v("評価項目 " + _vm._s(index + 1))]), _c('div', {
      staticClass: "col-sm-10"
    }, [_c('textarea', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (question.content),
        expression: "question.content"
      }],
      staticClass: "form-control",
      class: {
        required: !_vm.validation.content[index]
      },
      attrs: {
        "row": "3",
        "placeholder": "評価項目を入力してください"
      },
      domProps: {
        "value": _vm._s(question.content)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          question.content = $event.target.value
        }
      }
    }), _c('p', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.validation.content[index]),
        expression: "!validation.content[index]"
      }],
      staticClass: "validation-msg"
    }, [_vm._v(_vm._s(_vm.$t('validations.required')))])]), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 text-right"
    }, [_c('a', {
      staticClass: "btn btn-default",
      staticStyle: {
        "margin-right": "5px"
      },
      on: {
        "click": _vm.addContent
      }
    }, [_c('i', {
      staticClass: "fa fa-plus-square"
    }), _c('span', [_vm._v("追加")])]), _c('a', {
      staticClass: "btn btn-danger",
      class: {
        disabled: _vm.questions.length == 1
      },
      on: {
        "click": function($event) {
          _vm.deleteContent(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-square"
    }), _c('span', [_vm._v("削除")])])])])])
  }), _c('div', {
    staticClass: "row margin-top"
  }, [_c('div', {
    staticClass: "col-sm-12 text-right"
  }, [_c('a', {
    staticClass: "btn btn-info",
    class: {
      disabled: !_vm.validation.not_input
    },
    staticStyle: {
      "margin-right": "5px"
    },
    on: {
      "click": function($event) {
        _vm.onClickSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-floppy-o"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Save')))])]), _c('a', {
    staticClass: "btn btn-danger",
    on: {
      "click": function($event) {
        _vm.onClickCancel()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close"
  }), _c('span', [_vm._v(_vm._s(_vm.$t('Cancel')))])])])])], 2) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0d720e6d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./src/components/templates/normal-question-edit.pug
// module id = 754
// module chunks = 1